import React, { useState } from "react";
import { GraduationCap } from "lucide-react";
import { useStore } from "@/lib/store";
import { EmployeeAvatar } from "@/components/EmployeeAvatar";
import { KnowledgeManager } from "@/components/KnowledgeManager";

export default function AssociateTraining() {
  const { state } = useStore();
  const employees = state.employees || [];
  const [selectedId, setSelectedId] = useState(employees[0]?.id || null);
  const selected = employees.find((e) => e.id === selectedId) || employees[0];

  return (
    <div data-testid="associate-training-page">
      <div className="mb-6">
        <h1 className="flex items-center gap-2 font-display text-3xl font-semibold text-white sm:text-4xl">
          <GraduationCap className="text-[#00E5FF]" size={30} /> Associate Training
        </h1>
        <p className="mt-1 text-sm text-slate-400">Pick an associate and upload documents or links for them to review, learn and remember. Only that associate uses these.</p>
      </div>

      <div className="grid gap-6 lg:grid-cols-[260px_1fr]">
        {/* Associate picker */}
        <div className="space-y-2" data-testid="associate-picker">
          {employees.map((e) => {
            const active = e.id === selectedId;
            return (
              <button
                key={e.id}
                onClick={() => setSelectedId(e.id)}
                className={`flex w-full items-center gap-3 rounded-xl border p-3 text-left transition-colors ${active ? "border-[#00E5FF]/50 bg-[#00E5FF]/10" : "border-white/8 bg-[#030A16]/40 hover:border-white/20"}`}
                data-testid={`train-select-${e.id}`}
              >
                <EmployeeAvatar employee={e} size={40} showStatus={false} />
                <div className="min-w-0">
                  <div className="truncate text-sm font-semibold text-white">{e.name}</div>
                  <div className="truncate text-[11px] text-slate-400">{e.title}</div>
                </div>
              </button>
            );
          })}
        </div>

        {/* Knowledge for the selected associate */}
        <div className="rounded-2xl border border-white/8 bg-[#050D1C]/40 p-5">
          {selected && (
            <>
              <div className="mb-4 flex items-center gap-3">
                <EmployeeAvatar employee={selected} size={48} showStatus={false} />
                <div>
                  <div className="font-display text-lg font-semibold text-white">Training {selected.name}</div>
                  <div className="text-xs text-slate-400">{selected.title} · private knowledge base</div>
                </div>
              </div>
              <KnowledgeManager scope="associate" associateId={selected.id} key={selected.id} />
            </>
          )}
        </div>
      </div>
    </div>
  );
}
